import { render, staticRenderFns } from "./CurriculumPathSection.vue?vue&type=template&id=71df418f&scoped=true&"
import script from "./CurriculumPathSection.vue?vue&type=script&lang=js&"
export * from "./CurriculumPathSection.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumPathSection.vue?vue&type=style&index=0&id=71df418f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71df418f",
  null
  
)

export default component.exports